import { parseIdFilter, parsePagingQuery } from "../../handlers/filter";
export const toQueryParams = (filters) => {
    let queryParams = "";
    const idFilter = parseIdFilter(filters).values().next().value;
    if (idFilter) {
        queryParams += `?ids=["${idFilter}"]`;
    }
    if (!filters?.paging) {
        return queryParams;
    }
    queryParams = queryParams === "" ? "?" : "&";
    return queryParams + parsePagingQuery(filters?.paging);
};
//# sourceMappingURL=filters.js.map